import React from "react"
import { GItem } from "../../../../components/common/grids"
import { TextBox } from '../../../../components/common/inputs/textBox'
import FieldTitle from "./fieldTitle"
import { translate } from '../../../../../i18n'

type TextFieldProps = {
    name: string
    label: string
    maxLength: number
    row?: number
    minRows?: number
    required?: boolean
    title?: string
    isSubField?: boolean
    marginBottom?: number
}

const TextField: React.FC<TextFieldProps> = (props) => {
    const { name, label, required, maxLength, row, minRows, title, isSubField, marginBottom } = props;
    return (
        <GItem xs={12} mt={isSubField? 1: undefined} marginBottom={marginBottom}>
            {
                title && (
                    <FieldTitle 
                        title={title}
                        required={required}
                        isSubField={isSubField}
                    />
                )
            }
            <TextBox 
                name={name} 
                label={translate(label)} 
                required={required} 
                maxLength={maxLength} 
                multiline 
                rows={row}
                minRows={minRows}
                fullWidth 
            />
        </GItem>
    )
}

export default TextField;
